/**
 * Footer link columns. Source: SiteFooter mockup.
 * `href` starting with "/#" is a plain anchor on the home page; everything else is a router link.
 * Platform links go to the /platform page.
 */
export const FOOTER_TAGLINE = 'The AI-powered LMS and workforce readiness platform from Infylearn Technologies.';

export const FOOTER_COLUMNS = [
  {
    title: 'Platform',
    items: [
      { label: 'Skills and roles', href: '/platform' },
      { label: 'Content and authoring', href: '/platform' },
      { label: 'Learning and delivery', href: '/platform' },
      { label: 'EthosAI', href: '/platform#ethosai' },
      { label: 'Outcomes', href: '/platform' },
      { label: 'Governance', href: '/platform' },
    ],
  },
  {
    title: 'Industries',
    items: [
      { label: 'Oil, Gas and Energy', href: '/industries#oil-gas-energy' },
      { label: 'Healthcare and Pharma', href: '/industries#healthcare-pharma' },
      { label: 'BFSI', href: '/industries#bfsi' },
      { label: 'Manufacturing', href: '/industries#manufacturing' },
      { label: 'Aviation and Aerospace', href: '/industries#aviation-aerospace' },
      { label: 'Retail, Logistics, IT', href: '/industries#ecommerce-retail' },
    ],
  },
  {
    title: 'Resources',
    items: [
      { label: 'Skills framework', href: '/resources/skills-framework' },
      { label: 'Interaction gallery', href: '/resources/interaction-gallery' },
      { label: 'Report gallery', href: '/resources/report-gallery' },
      { label: 'Guides and glossary', href: '/resources/guides' },
      { label: 'Comparisons', href: '/resources/comparisons' },
      { label: 'Client stories', href: '/resources/client-stories' },
    ],
  },
  {
    title: 'Company',
    items: [
      { label: 'About Infylearn', href: '/company' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'Contact', href: '/enquiry' },
      { label: 'Book a demo', href: '/enquiry' },
    ],
  },
];